// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"AddIngredients_inputArea__3fVRR","ingredientFields":"AddIngredients_ingredientFields__3Nado","buttonArea":"AddIngredients_buttonArea__bj5pb"};